export const ADMINISTRATOR_SCOPES = {
  SUPER: "super",
  ADMIN: "admin",
  CLIENT_ADMIN: "client admin",
  CLIENT_VIEWER: "client",
};

const SCOPE_PRIORITY = [
  ADMINISTRATOR_SCOPES.SUPER,
  ADMINISTRATOR_SCOPES.ADMIN,
  ADMINISTRATOR_SCOPES.CLIENT_ADMIN,
  ADMINISTRATOR_SCOPES.CLIENT_VIEWER,
];

const SCOPE_LABELS = {
  [ADMINISTRATOR_SCOPES.SUPER]: "Super",
  [ADMINISTRATOR_SCOPES.ADMIN]: "Admin",
  [ADMINISTRATOR_SCOPES.CLIENT_ADMIN]: "Client Admin",
  [ADMINISTRATOR_SCOPES.CLIENT_VIEWER]: "Client Viewer",
};

const SCOPE_PERMISSION_MATRIX = {
  [ADMINISTRATOR_SCOPES.SUPER]: [
    ADMINISTRATOR_SCOPES.SUPER,
    ADMINISTRATOR_SCOPES.ADMIN,
    ADMINISTRATOR_SCOPES.CLIENT_ADMIN,
    ADMINISTRATOR_SCOPES.CLIENT_VIEWER,
  ],
  [ADMINISTRATOR_SCOPES.ADMIN]: [
    ADMINISTRATOR_SCOPES.CLIENT_ADMIN,
    ADMINISTRATOR_SCOPES.CLIENT_VIEWER,
  ],
  [ADMINISTRATOR_SCOPES.CLIENT_ADMIN]: [
    ADMINISTRATOR_SCOPES.CLIENT_ADMIN,
    ADMINISTRATOR_SCOPES.CLIENT_VIEWER,
  ],
  [ADMINISTRATOR_SCOPES.CLIENT_VIEWER]: [],
};

export const normalizeAdministratorScope = (value) => {
  const normalizedValue = String(value ?? "")
    .trim()
    .toLowerCase()
    .replace(/[_-]+/g, " ")
    .replace(/\s+/g, " ");

  switch (normalizedValue) {
    case "superadmin":
    case "super admin":
    case "super":
      return ADMINISTRATOR_SCOPES.SUPER;
    case "admin":
      return ADMINISTRATOR_SCOPES.ADMIN;
    case "client admin":
    case "client administrator":
      return ADMINISTRATOR_SCOPES.CLIENT_ADMIN;
    case "client viewer":
    case "client":
    case "viewer":
      return ADMINISTRATOR_SCOPES.CLIENT_VIEWER;
    default:
      return normalizedValue;
  }
};

export const getHighestAdministratorScope = (scopeValues = []) => {
  const normalizedScopes = scopeValues
    .flatMap((value) => (Array.isArray(value) ? value : [value]))
    .map(normalizeAdministratorScope)
    .filter(Boolean);

  return SCOPE_PRIORITY.find((scope) => normalizedScopes.includes(scope)) || "";
};

export const getAdministratorScopeLabel = (value) => {
  const normalizedScope = normalizeAdministratorScope(value);
  return SCOPE_LABELS[normalizedScope] || normalizedScope;
};

export const getAllowedAdministratorScopes = (currentScope) => {
  const normalizedScope = normalizeAdministratorScope(currentScope);
  return [...(SCOPE_PERMISSION_MATRIX[normalizedScope] || [])];
};

export const canAccessAdministrators = (currentScope) => {
  return getAllowedAdministratorScopes(currentScope).length > 0;
};

export const canManageAdministratorScope = (currentScope, targetScope) => {
  const normalizedTargetScope = normalizeAdministratorScope(targetScope);
  if (!normalizedTargetScope) {
    return false;
  }
  return getAllowedAdministratorScopes(currentScope).includes(normalizedTargetScope);
};
